import React from 'react';
import CommonPreviewComponent from './CommonPreviewComponent';
import getLocaleMessages from '../../utils/localesMessages';
const messages = getLocaleMessages('buttonsV3/buttonPreview');

const ButtonFactoryV3MobilePreview = () => {
  return (
    <div
      id="phone-component-v3"
      className="phone-component-container"
      data-testid="phone-component"
      role="region"
      aria-label={messages.navigator.fullPage.mobileAccessibility}
    >
      <div className="phone-component-top-marker-container" aria-hidden="true">
        <div className="phone-component-top-marker-1" />
        <div className="phone-component-top-marker-2" />
      </div>
      <CommonPreviewComponent isMobile={true} />

      <div className="phone-component-bottom-marker" aria-hidden="true" />
    </div>
  );
};

export default ButtonFactoryV3MobilePreview;
